/* global axios */
import ApiClient from './ApiClient';

class QuotesAPI extends ApiClient {
  constructor() {
    super('quotes', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(quoteData) {
    return axios.post(this.url, { quote: quoteData });
  }

  update(id, quoteData) {
    return axios.patch(`${this.url}/${id}`, { quote: quoteData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  sendQuote(id, method = 'conversation') {
    return axios.post(`${this.url}/${id}/send`, { method });
  }

  accept(id) {
    return axios.post(`${this.url}/${id}/accept`);
  }

  reject(id, reason = '') {
    return axios.post(`${this.url}/${id}/reject`, { reason });
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`, { responseType: 'blob' });
  }

  addLineItem(id, itemData) {
    return axios.post(`${this.url}/${id}/add_line_item`, itemData);
  }

  removeLineItem(id, itemId) {
    return axios.delete(`${this.url}/${id}/remove_line_item`, { params: { item_id: itemId } });
  }
}

export default new QuotesAPI();
